import { memo } from 'react';
import { Handle } from '@xyflow/react';
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';
import { RemoteNodeType } from '../../../../types';
import './CustomNode.scss'
import { FileSvg } from './Svgs';


function CustomNode({ data }: { data: RemoteNodeType['data'] }) {
    const { label, componentType, status, rootNode, icon, loading, onConnect, onDownload, handlers, selected } = data;

    return (
        <button className={`custom__node__container 
            ${rootNode ? 'root__node' : ''}
            ${status === 'CONNECTED' ? 'connected' : (status === 'DISCONNECTED' || status === 'TIMEOUT') ? 'disconnected' : ''}`}
        >
            <div className='custom__node__header__container'>
                <div className='node__connection__status__container' />
                <div className='node__icon__container'>
                    {icon}
                </div>
                <div className='node__title__container'>
                    <CustomToolTip title={label} placement='top-start'>{label}</CustomToolTip>
                </div>
            </div>
            <div className='custom__node__footer__container'>
                <div className='node__badge'>
                    {componentType}
                </div>
                {selected &&
                    <button className='node__icon__container'
                        onClick={onDownload}
                    >
                        <FileSvg />
                    </button>
                }
            </div>
            {handlers.map((handler, index) => {
                return (
                    <Handle
                        key={index}
                        id={handler.id}
                        type={handler.type}
                        position={handler.position}
                        className="node__handler"
                    />
                )
            })}
        </button>
    );
}

export default memo(CustomNode);

